import { render, staticRenderFns } from "./ManifestApproval.vue?vue&type=template&id=2a0d65ad&"
import script from "./ManifestApproval.vue?vue&type=script&lang=js&"
export * from "./ManifestApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports